import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';
import { FetchQueryParams } from '../../web-api/services/types';
import { ApiClientBrowseParams, ApiClientParams, ApiClientSearchParams } from './ApiClient';

export function buildBrowseRequestQuery(params: ApiClientBrowseParams): FetchQueryParams {
  const { categoryIds, biData } = params;
  const { category, subCategory, criteria, isForYouPage } = biData;
  return {
    'category-ids': joinArray(categoryIds),
    category,
    'sub-category': subCategory,
    criteria,
    page: String(params.biData.page),
    'is-for-you-page': isForYouPage ? 'true' : 'false',
    ...buildRequestQuery(params),
  };
}

export function buildSearchRequestQuery(params: ApiClientSearchParams): FetchQueryParams {
  const { criteria } = params;
  return {
    criteria,
    page: String(params.biData.page),
    ...buildRequestQuery(params),
  };
}

function buildRequestQuery(params: ApiClientParams): FetchQueryParams {
  const { filters, sortCategoryId, templatePageSessionId } = params;
  const query = {
    offset: 'offset' in params ? String(params.offset) : null,
    limit: 'limit' in params ? String(params.limit) : null,
    apps: joinArray(filters && filters.apps),
    features: joinArray(filters && filters.features),
    layouts: joinArray(filters && filters.layouts),
    colors: joinArray(filters && filters.colors),
    'color-styles': joinArray(filters && filters.colorStyles),
    'sort-category-id': sortCategoryId,
    'template-page-session-id': templatePageSessionId,
  };

  return omitBy(query, isEmpty);
}

function joinArray(arr?: string[]): string {
  return (arr || []).join(',');
}
